































import { Component, Vue } from 'vue-property-decorator'
import newDaliog from './new-dialog.vue'
import oldDaliog from './old-dialog.vue'
import { CommonMudule } from '@/store/modules/common'

@Component({
  name: 'user',
  components: {
    newDaliog,
    oldDaliog
  }
})
export default class extends Vue {
  userList =[{
    label: '新客户',
    value: 1,
    logo: '+'
  }, {
    label: '已有客户',
    value: 2,
    logo: '2'
  }]

  n = 2
  get getName () {
    const router = this.$route.path
    let name
    if (router === '/userSelect') {
      name = '客户'
    } else {
      name = CommonMudule.customerName
    }
    return name
  }

  get route () {
    const router = this.$route.path
    return router
  }

  public setItem (key: any, value: any) {
    window.sessionStorage.setItem(key, value)
  }

  public getItem (key: string) {
    return sessionStorage.getItem(key)
  }

  get slogan () {
    return CommonMudule.imgSource.slogan
  }

  get logoUrl () {
    return CommonMudule.imgSource.logo
  }

  changeList (index: number) {
    this.n = index// this指向app
    console.log(index)
    if (index === 0) {
      (this.$refs.newDialog as any).show()
    } else {
      (this.$refs.oldDaliog as any).showDialog()
    }
  }
}
